import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { ModalType } from '@frontend/modal';
import { NotificationTemplateClient } from '@frontend/notification/api';
import { NotificationTemplate } from '@frontend/notification/types';

import { ApplicationCreateButton } from '../../components/create-button';
import OverviewHeader from '../../header/overview-header';
import { CreateTemplateModal } from './create-template-modal/create-template-modal.component';
import { useTemplates } from './templates.controller';

export const Templates = () => {
    const viewProps = useTemplates();
    return (
        <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={CommonMessage.OBJECTS.NOTIFICATION_TEMPLATE.PLURAL}
                createButton={
                    <ApplicationCreateButton
                        modalId={viewProps.templateModalId}
                        renderDefaultModal={() => <CreateTemplateModal />}
                        modalOptions={{ type: ModalType.PANE, className: 'max-w-[900px]' }}
                        createPermissions={viewProps.createTemplatePermissions}
                        entity={<span className='lowercase'>{CommonMessage.OBJECTS.NOTIFICATION_TEMPLATE.DEFAULT}</span>}
                    />
                }
            />
            <ReactiveObjectList<NotificationTemplate>
                id='notification-templates-list'
                useStaticListId
                fetch={(arg) => NotificationTemplateClient.fetchNotificationTemplates(arg)}
                dispatch={viewProps.dispatch}
                type={EntityType.NOTIFICATION_TEMPLATE}
                columns={{ columns: ['name', 'description', 'creation_timestamp', 'update_timestamp'] }}
                onSelectElement={(obj) => viewProps.navigate(`./${obj.id}/details`)}
                eventListener={EntityType.NOTIFICATION_TEMPLATE}
                activeFilter={{
                    searchKeys: ['name', 'description']
                }}
            />
        </div>
    );
};
